import { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";

import { FaBan, FaUndoAlt, FaClock, FaCalendarTimes, FaExclamationTriangle, FaTools, FaUserSlash, FaFileAlt, FaPhoneAlt, FaShieldAlt } from "react-icons/fa";
import Navbarsticky from "./NavbarSticky";
import Footer from "./Footer";

export default function Refund() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            {/* Navbar */}
            <Navbarsticky />
            <div className="refund-container">
            </div>

            {/* MAIN CONTENT */}
            <div className="refund-section py-5 w-100">
                <Container fluid className="w-100">
                    <Row className="justify-content-center">
                        <h1 className="refund-title">
                            <FaUndoAlt className="title-icon" />
                            Refund & Cancellation Policy
                        </h1>
                        <Col lg={9} md={11}>
                            <div className="refund-card">
                                <p className="refund-subtitle">Last Updated: on</p>
                                <p>
                                    At <strong>https://amh.octaloptimum.in/</strong>, we
                                    understand that travel plans may change. Our Refund and
                                    Cancellation Policy is designed to be transparent and fair to
                                    both our customers and the service provider.
                                </p>

                                {/* 1. Cancellation by Customer */}
                                <div className="refund-block">
                                    <h5><FaBan className="block-icon" /> Cancellation by Customer</h5>
                                </div>

                                <h6 className="sub-heading"><FaCalendarTimes className="bullet-icon" /> Before Confirmation</h6>
                                <ul>
                                    <li>
                                        If you cancel before the booking is confirmed and no payment
                                        is made, no cancellation fee applies.
                                    </li>
                                </ul>

                                <h6 className="sub-heading"><FaCalendarTimes className="bullet-icon" /> After Booking Confirmation</h6>
                                <ul>
                                    <li>
                                        Cancellations made <strong>15 days or more</strong> prior:
                                        <br /><strong>80% refund</strong>
                                    </li>
                                    <li>
                                        Cancellations made <strong>7–14 days</strong> prior:
                                        <br /><strong>50% refund</strong>
                                    </li>
                                    <li>
                                        Cancellations made <strong>less than 7 days</strong> prior:
                                        <br /><strong>No refund</strong>
                                    </li>
                                </ul>

                                <p>
                                    Note: Some packages may have special non-refundable terms.
                                </p>

                                {/* 2. Cancellation by Company */}
                                <div className="refund-block">
                                    <h5>
                                        <FaShieldAlt className="block-icon" />
                                        Cancellation by https://amh.octaloptimum.in/
                                    </h5>
                                </div>

                                <p>
                                    In rare cases where we cancel due to unforeseen circumstances:
                                </p>
                                <ul>
                                    <li>Full refund of the amount paid; or</li>
                                    <li>Option to reschedule or use credit for future booking.</li>
                                </ul>

                                {/* 3. Partial Cancellations */}
                                <div className="refund-block">
                                    <h5><FaTools className="block-icon" /> Partial Cancellations & Modifications</h5>
                                </div>

                                <ul>
                                    <li>
                                        Individual components like hotels or activities may be cancelled independently.
                                    </li>
                                    <li>Modifications may have additional charges.</li>
                                </ul>

                                {/* 4. Refund Timelines */}
                                <div className="refund-block">
                                    <h5><FaClock className="block-icon" /> Refund Timelines</h5>
                                </div>

                                <ul>
                                    <li>
                                        Refunds processed within <strong>7–14 business days</strong>.
                                    </li>
                                    <li>Refunded to the <strong>original payment method</strong>.</li>
                                    <li>Bank processing time may vary.</li>
                                </ul>

                                {/* 5. Non-Refundable */}
                                <div className="refund-block">
                                    <h5><FaFileAlt className="block-icon" /> Non-Refundable Components</h5>
                                </div>

                                <p>The following will not be refunded:</p>
                                <ul>
                                    <li>Booking fees or administrative charges.</li>
                                    <li>Visa, insurance, or documentation costs.</li>
                                    <li>Partially utilized services.</li>
                                    <li>Packages labelled “non-refundable”.</li>
                                </ul>

                                {/* 6. Force Majeure */}
                                <div className="refund-block">
                                    <h5><FaExclamationTriangle className="block-icon" /> Force Majeure</h5>
                                </div>

                                <p>We are not liable for cancellations due to:</p>
                                <ul>
                                    <li>Natural disasters</li>
                                    <li>Political unrest or strikes</li>
                                    <li>Acts of government</li>
                                    <li>Epidemics or pandemics</li>
                                </ul>

                                {/* 7. No Show */}
                                <div className="refund-block">
                                    <h5><FaUserSlash className="block-icon" /> No Show Policy</h5>
                                </div>

                                <ul>
                                    <li>Failure to show up is considered a <strong>“No Show”</strong>.</li>
                                    <li><strong>No refund</strong> will be processed.</li>
                                </ul>

                                {/* 8. How to Cancel */}
                                <div className="refund-block">
                                    <h5><FaUndoAlt className="block-icon" /> How to Cancel a Booking</h5>
                                </div>

                                <p>To request a cancellation:</p>
                                <ul>
                                    <li>Go to <strong>“My Bookings”</strong> section.</li>
                                    <li>Submit a cancellation request.</li>
                                </ul>

                                <p>
                                    Or email: andamanmakeholidayss@gmail.com with your booking ID.
                                </p>

                                {/* 9. Contact */}
                                <div className="refund-block">
                                    <h5><FaPhoneAlt className="block-icon" /> Contact Us</h5>
                                </div>

                                <p>
                                    For support:<br />
                                    Email: andamanmakeholidayss@gmail.com<br />
                                    Phone: +91-8145080001<br />
                                    Working Hours: Monday–Saturday, 10 AM – 6 PM IST
                                </p>

                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>

            {/* Footer */}
            <Footer/>
        </>
    );
}
